import React from 'react';
import { format, parseISO } from 'date-fns';
import { FormSection } from '@components/form-section';
import { Badge } from '@components/ui/badge';
import { CommunityApp } from '@core/api/ChallengeClient';

const InstalledAppsSection = ({ apps }: { apps?: CommunityApp[] }) => (
    <FormSection title="Installed Apps">
        {!apps ? (
            <p className="text-sm text-muted-foreground italic">
                Not configured, the mobile app shows its default apps
            </p>
        ) : apps.length === 0 ? (
            <p className="text-sm text-muted-foreground italic">
                No apps installed
            </p>
        ) : (
            <ol className="flex flex-col gap-2 text-sm">
                {apps.map((app) => (
                    <li key={app.appId} className="flex items-center gap-3">
                        <Badge variant="outline">{app.appId}</Badge>
                        <span className="text-xs text-muted-foreground">
                            Installed{' '}
                            {format(parseISO(app.installedDate), 'dd.MM.yy')}
                            {app.installedBy && ` by ${app.installedBy}`}
                        </span>
                    </li>
                ))}
            </ol>
        )}
    </FormSection>
);

export default InstalledAppsSection;
